import { ClickTracker } from 'bernie-plugin-analytics';
import { Link } from 'react-router-dom';
import { UitkExternalButton, UitkOverlayButton, UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from 'uitk-react-button';
import { UitkCheckbox } from 'uitk-react-checkbox';
import { UitkImageLink } from 'uitk-react-images';
import { UitkFakeInput } from 'uitk-react-input';
import { UitkRadioButton } from 'uitk-react-radio-button';
var ANCHOR = 'a';
var BUTTON = 'button';
export var CheckboxTracked = ClickTracker(UitkCheckbox);
export var TertiaryButtonTracked = ClickTracker(UitkTertiaryButton);
export var RadioButtonTracked = ClickTracker(UitkRadioButton);
export var PrimaryButtonTracked = ClickTracker(UitkPrimaryButton);
export var SecondaryButtonTracked = ClickTracker(UitkSecondaryButton);
export var LinkTracked = ClickTracker(Link);
export var FakeInputTracked = ClickTracker(UitkFakeInput);
export var AnchorTracked = ClickTracker(ANCHOR);
export var ImageLinkTracked = ClickTracker(UitkImageLink);
export var ButtonTracked = ClickTracker(BUTTON);
export var OverlayButtonTracked = ClickTracker(UitkOverlayButton);
export var ExternalButtonTracked = ClickTracker(UitkExternalButton);